import { makeAutoObservable } from "mobx";
import { IChangeable } from "../../../../../../stores/types";
import { IInputValitationResponse } from "../../../../../../hooks/input-validation-hook";

interface IReservedItemDaysRemaining {
    from?: number;
    to?: number;
}

interface IChanges extends Partial<IReservedItemDaysRemaining> { };

export class ReservedItemDaysRemainingStore implements IChangeable<IReservedItemDaysRemaining> {
    private _changes: IChanges = {};
    private _model: IReservedItemDaysRemaining = { from: undefined, to: undefined };
    private _validationErrorMessages: string[] = [];

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get from(): number | undefined {
        return this._changes.from ?? this._model.from;
    }

    public get to(): number | undefined {
        return this._changes.to ?? this._model.to;
    }

    public get validationErrorMessages(): string[] {
        return this._validationErrorMessages;
    }

    public setFrom(value: number) {
        this._changes.from = value;
    }

    public setTo(value: number) {
        this._changes.to = value;
    }

    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {};
    }

    /** Clears committed and draft from/to (e.g. filter clear or switching expiration type). */
    public reset(): void {
        this._model = { from: undefined, to: undefined };
        this._changes = {};
        this._validationErrorMessages = [];
    }

    public getUpdatedModel(): IReservedItemDaysRemaining {
        return { ...this._model, ...this._changes }
    }

    public commitChanges() {
        const model = this.getUpdatedModel();
        this._model = model;
        this.discardChanges();
    }

    public validate(): IInputValitationResponse {
        let isValid: boolean = true;
        let messages: string[] = [];

        if (this.from === undefined || this.to === undefined) {
            return {
                isValid: false,
                messages: []
            }
        }

        if (this.from >= this.to) {
            isValid = false;
            messages.push('Start number should be lower than the end number');
        }

        this._validationErrorMessages = messages;

        return {
            isValid: isValid,
            messages: messages,
        }    
    }
}
